import {FC} from "react";
import {arrayFromNumber} from "../../../helper/functions";

interface IProps {
  icon?: React.ReactNode;
  title?: string;
  clusters?: number;
  activeClusters?: number;
  description?: string;
}

export const BlockGraphLevelTrend: FC<IProps> = ({
  icon,
  title,
  clusters = 9,
  activeClusters,
  description,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {icon && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: 10,
          }}
        >
          <div>
            <img
              src={icon as string}
              alt={"FlagRuIcon"}
              width="20"
              height="20"
            />
          </div>

          <div style={{color: "#fff"}}>{title}</div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          justifyContent: "start",
          color: "#fff",
        }}
      >
        {activeClusters && !description
          ? arrayFromNumber(clusters).map((item) => {
              return (
                <div
                  key={item}
                  style={{
                    background: item < activeClusters ? "#0082ED" : "#22272B",
                    width: 20,
                    height: 13,
                    borderRadius: 3,
                  }}
                />
              );
            })
          : description}
      </div>
    </div>
  );
};
